import * as React from "react";
import { durationDataString } from "public@tool/handler";
import Animation from "../animation";
import "./style/style.scss";
import { observer, inject } from "mobx-react";
import { action } from "pc@action/index";
import VideoPalyer from "../videoPlayer/index";
import VideoPlayerMp4 from "../videoPlayer/videoMp4";
// import { getQueryString } from "public@tool/getQuery";
interface IProps {
  store?: any;
}

interface IState {
  status: {
    WAIT: string;
    PAUSE: string;
    END: string;
    LIVING: string;
    NOT_FOUND: string;
  };
  countDown: string | boolean;
  isCountDown: boolean;
}

const h = window.location.origin;
@inject("store")
@observer
export default class PublicPlayComponent extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      status: {
        WAIT: "距离直播还有",
        PAUSE: "直播已暂停",
        END: "直播已结束",
        LIVING: "直播进行中",
        NOT_FOUND: "直播不存在"
      },
      countDown: "",
      isCountDown: true
    };
  }

  public componentDidMount() {
    const { liveStatus } = this.props.store;
    if (liveStatus === "WAIT") {
      this.countDown();
    }
  }

  public countDown() {
    const el: Element = document.querySelector("#countDown") as Element;
    const { timeStart } = this.props.store.liveInfo;
    const si = setInterval(() => {
      const dt = durationDataString(timeStart);
      if (!dt) {
        this.setState({ isCountDown: false });
        clearInterval(si);
        el.innerHTML = `<p>直播即将开始</p>`;
      } else {
        if (dt.days > 0) {
          clearInterval(si);
          el.innerHTML = `${dt.days}天`;
        } else {
          el.innerHTML = `<p>${dt.hours}<span>小时</span>${dt.mins}<span>分</span>${
            dt.seconds
          }<span>秒</span></p>`;
        }
      }
    }, 1000);
  }

  public beginLivePlayback = () => {
    action.beginLivePlayback(0);
  };
  public downloadFlash = () => {
    window.location.href = "http://get.adobe.com/cn/flashplayer/";
  };
  public playerStateChanged(playerCurrentState: any) {
    // console.log('player current update state', playerCurrentState)
  }

  public playerReadied = (player: any) => {
    console.log("reday:::", player);
    // const { channels } = this.props.store player.src(`https:${channels[0].src}`)
  };

  public render() {
    const {
      interactiveType,
      isPlay,
      playbackStatus,
      liveStatus,
      feeAmount,
      liveId,
      isFeeLive,
      videoPlayerOption,
      isMp4,
      playbackIndex,
      browserFlash
    } = this.props.store;
    const { countDown, status, isCountDown } = this.state;
    return (
      <div className="play-container">
        {isPlay ? (
          <div className="video__player--container">
            {browserFlash && (
              <div className="video__player--flash" onClick={this.downloadFlash}>
                <Animation interactiveType={interactiveType} />
                请点击此处点击下载Flash
              </div>
            )}
            {!isMp4 &&
              !browserFlash && (
                <VideoPalyer
                  option={videoPlayerOption.option}
                  sources={videoPlayerOption.sources}
                  statechanged={this.playerStateChanged}
                  ready={this.playerReadied}
                />
              )}

            {isMp4 &&
              !browserFlash && (
                <VideoPlayerMp4
                  index={playbackIndex}
                  option={videoPlayerOption.option}
                  sources={videoPlayerOption.sources}
                />
              )}
          </div>
        ) : (
          <div className="live__status">
            <div className="live__logo">
              <Animation interactiveType={interactiveType} />
            </div>
            <div className="live__info--container">
              <div className="live__status-info">
                {isCountDown && <p>{status[liveStatus]}</p>}
                {!countDown && <div id="countDown" />}
              </div>

              {playbackStatus &&
                !isPlay &&
                isFeeLive && (
                  <div className="playback__status">
                    <button
                      className="btn-style btn-a-link btn__playback"
                      onClick={this.beginLivePlayback}
                    >
                      观看回放
                    </button>
                  </div>
                )}

              {!isFeeLive && (
                <a
                  href={`${h}/live/vpay/pc/phonecheck?liveId=${liveId}`}
                  className="btn-style btn-a-link"
                >
                  收费直播 ￥{feeAmount}
                </a>
              )}
            </div>
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pc/component/player/index.tsx